import React from "react";

import AgentSourceIcon from "./AgentSourceIcon";
import PlaybookRunService from "../../services/PlaybookRunService";

import "./agent-source-list.css";

class AgentSourceList extends React.PureComponent {
	dotClassFor(source) {
		if (source.isConnected) return "tk-dot tk-dot--success";
		if (source.isRequired) return "tk-dot tk-dot--danger";
		return "tk-dot tk-dot--warning";
	}

	renderConnection(source) {
		if (source.isConnected === undefined) return null;
		return (
			<span className="agent-source-list__state">
				<span className={this.dotClassFor(source)} />
				{source.isConnected ? "Linked" : "Not linked"}
			</span>
		);
	}

	renderConnectAction(source) {
		const { onConnect } = this.props;
		const action = PlaybookRunService.describeConnectAction({ connectWhere: source.connectWhere });
		if (!action.label) return null;
		if (!action.canConnect) return <div className="agent-source-list__ask">Only an administrator can connect this. Ask one to do it.</div>;
		if (!onConnect) return null;
		return (
			<button type="button" className="tk-text-action agent-source-list__connect" onClick={() => onConnect({ source, action })}>
				{action.label}
			</button>
		);
	}

	renderCompact() {
		const { sources, onConnect } = this.props;
		const missing = sources.filter(source => source.isConnected === false);
		const firstMissing = missing[0];
		const firstMissingAction = firstMissing ? PlaybookRunService.describeConnectAction({ connectWhere: firstMissing.connectWhere }) : null;
		const blocking = missing.filter(source => source.isRequired);

		return (
			<div className="agent-source-list--compact">
				{sources.map(source => (
					<span
						key={source.key}
						className="agent-source-list__chip"
						title={source.isConnected ? `${source.label}: linked` : `${source.label}: not linked — ${source.connectInstruction}`}
					>
						<AgentSourceIcon icon={source.icon} size="small" />
						{source.label}
						<span className={this.dotClassFor(source)} />
					</span>
				))}
				{blocking.length > 0 && (
					<span className="agent-source-list__compact-note">Connect {blocking.map(source => source.label).join(" and ")} to run it</span>
				)}
				{firstMissingAction && firstMissingAction.canConnect && onConnect && (
					<button
						type="button"
						className="tk-text-action agent-source-list__connect"
						onClick={() => onConnect({ source: firstMissing, action: firstMissingAction })}
					>
						{firstMissingAction.label}
					</button>
				)}
			</div>
		);
	}

	render() {
		const { sources, isCompact } = this.props;
		if (!sources || sources.length === 0) return null;
		if (isCompact) return this.renderCompact();

		return (
			<ul className="agent-source-list">
				{sources.map(source => {
					const isMissing = source.isConnected === false;
					return (
						<li key={source.key} className="agent-source-list__row">
							<AgentSourceIcon icon={source.icon} />
							<div className="agent-source-list__text">
								<div className="agent-source-list__name">
									{source.label}
									<span className="agent-source-list__need">{source.isRequired ? "Required" : "Helpful"}</span>
								</div>
								<div className="agent-source-list__detail">{isMissing ? source.connectInstruction : source.reads}</div>
								{isMissing && this.renderConnectAction(source)}
							</div>
							{this.renderConnection(source)}
						</li>
					);
				})}
			</ul>
		);
	}
}

export default AgentSourceList;
